import React from 'react';
import FlipbookViewer from './flipbookviewer/FlipbookViewer';

export default function FlipbookPage() {
  // The demo PDF should be placed at `public/demo.pdf` so it's served from '/demo.pdf'
  const pdfUrl = '/Synapse.pdf';

  return (
    <div style={{ height: '100vh', width: '100%', margin: 0, padding: 0 }}>
      <FlipbookViewer pdfUrl={pdfUrl} />
    </div>
  );
}

